export const ingredientListDualHint = `
  The ingredient list shows ingredients in descending weight order,
  which we figure out automatically for you based on the recipe.
  <br><br>
  Most common public ingredients we've already set default ingredient lists
  (using common names (like 'Flour' and 'Butter') and including any subingredients
  in parenthesis), but you can change how ingredient statements are displayed on your labels
  using this field. You can use <code>&lt;b&gt;</code> and <code>&lt;/b&gt;</code> tags to bold text in the English (FDA) field or Manual Edit; bolding is not supported on Canadian labels.
  <br><br>
  For questions and more complete rules:
  <br>
  <a
  href='https://www.ecfr.gov/current/title-21/chapter-I/subchapter-B/part-101/subpart-A/section-101.4'
  target='_blank'>FDA Ingredient List Guide</a>
  <br>
  <a href='https://inspection.canada.ca/food-labels/labelling/industry/list-of-ingredients-and-allergens/eng/1628716222800/1628716311275'
  target='_blank'>CFIA Ingredient List Guide</a>`;

export const ingredientListEnglishHint = `
  The ingredient list shows ingredients in descending weight order,
  which we figure out automatically for you based on the recipe.
  <br><br>
  Most common public ingredients we've already set default ingredient lists
  (using common names (like 'Flour' and 'Butter') and including any subingredients
  in parenthesis), but you can change how ingredient statements are displayed on your labels
  using this field.
  <br><br>
  For questions and more complete rules, take a look at the
  <a
  href='https://www.ecfr.gov/current/title-21/chapter-I/subchapter-B/part-101/subpart-A/section-101.4'
  target='_blank'>FDA Ingredient List Guide</a>.`;

export const ingredientListFrenchHint = `
  The ingredient list shows ingredients in descending weight order,
  which we figure out automatically for you based on your recipe.
  <br><br>
  Most common public ingredients we've already set default ingredient
  lists (using common names (like 'Flour' and 'Butter') and including
  any subingredients in parenthesis), but you can change how French
  ingredient statements are displayed on your labels using this field.
  <br><br>
  For questions and more complete rules, take a look at the
  <a href='https://inspection.canada.ca/food-labels/labelling/industry/list-of-ingredients-and-allergens/eng/1628716222800/1628716311275'
  target='_blank'>CFIA Ingredient List Rules</a>.`;

export const spiceFlavorHint = `
  Certain flavors and spices can be aggregated together and listed as 'Spices', 'Flavors' (or a
  variation on the terms) in the ingredient list.
  <br><br>
  Please refer to this
  <a href='https://www.ecfr.gov/current/title-21/chapter-I/subchapter-B/part-101/subpart-B/section-101.22'
     target='_blank'>FDA link</a> to see what qualifies under each term.
  <br><br>
  Be careful, as common ingredients like Garlic and Onion Powder do NOT qualify, so please
  review the link first and use this feature carefully.
`;

export const canadaSugarHint = `
  For Canadian nutrition labels sugars are required to be aggregated by weight and listed
  together in parenthesis under 'Sugar', as if a single ingredient. We'll try to denote those
  ingredients automatically, but you can manually control that setting here.
  <br><br>
  You can read more about the new rule
  <a href='https://www.canada.ca/en/health-canada/services/food-labelling-changes/sugars.html'
    target='_blank'>here</a>.
  <br><br>
  This will only affect the ingredient statements of labels using any of the Canadian formats.
`;

export const bioengineeredHint = `
  The USDA mandates that certain foods containing bioengineered (BE) ingredients
  must disclose this information to consumers. You can mark specific ingredients
  as being bioengineered here.
  <br><br>
  Not all foods are required to disclose BE ingredients, and food manufacturers
  with annual receipts less than $2,500,000 are exempt from the labeling
  requirements.  You can read more about the USDA's BE labeling requirements <a
  href='https://www.recipal.com/blog/food-label-news/labeling-foods-with-bioengineered-ingredients'
  target='_blank'>on our blog</a>.
  <br><br>
  If your product contains BE ingredients, you'll have the option to add the
  disclosure to your label.
`;

export const subrecipeIngredientMetaNameHint = `
  When you use a subrecipe in another recipe the subrecipe ingredient statement will show up
  with the name of the recipe by default, followed by the full ingredient statement in
  parenthesis with all the subingredients.
  <br><br>
  Instead of using the recipe name you can set how you want it to show here.
`;

export const errorHelpTip =
  "You can refresh, and if needed, try again. Don't hesitate to contact support!";
